import { combineReducers } from "redux";
import userReducer from "./user/user.reducer";
import contractReducer from "./contract/contract.reducer";
import companyReducer from "./company/company.reducer";
import snackbarReducer from "./snackbar/snackbar.reducer";
import errorReducer from "./error/error.reducer";

export default combineReducers({
    user: userReducer,
    errors: errorReducer,
    contract: contractReducer,
    company : companyReducer,
    snackbar : snackbarReducer
})